const sqrt = Math.sqrt;
export default sqrt;
